import React, { useEffect, useState } from 'react';
import { Modal, Form, Select, Checkbox, App } from 'antd';
import { getAllSales } from '../../services/userService';
import { WAConversation, WAAssignPayload } from '../../types/whatsapp';
import { User } from '../../types';

const { Option } = Select;

interface AssignModalProps {
  open: boolean;
  conversation: WAConversation | null;
  onCancel: () => void;
  onSubmit: (payload: WAAssignPayload) => Promise<void>;
}

const AssignModal: React.FC<AssignModalProps> = ({ open, conversation, onCancel, onSubmit }) => {
  const [form] = Form.useForm();
  const { message } = App.useApp();
  const [salesUsers, setSalesUsers] = useState<User[]>([]);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!open) return;
    let active = true;
    (async () => {
      setLoadingUsers(true);
      try {
        const envelope = await getAllSales();
        if (active) setSalesUsers(envelope?.data || []);
      } catch (error) {
        console.error(error);
        if (active) message.error('Gagal memuat daftar sales');
      } finally {
        if (active) setLoadingUsers(false);
      }
    })();
    return () => {
      active = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  useEffect(() => {
    if (open) {
      form.setFieldsValue({
        assigned_to_id: conversation?.assigned_to_id,
        create_lead: false,
      });
    } else {
      form.resetFields();
    }
  }, [open, conversation, form]);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      setSubmitting(true);
      await onSubmit({
        assigned_to_id: values.assigned_to_id,
        create_lead: !!values.create_lead,
      });
    } catch (error) {
      // validation error or already surfaced upstream
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      title="Assign Percakapan"
      open={open}
      onOk={handleOk}
      onCancel={onCancel}
      confirmLoading={submitting}
      destroyOnClose
      okText="Assign"
      cancelText="Batal"
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="assigned_to_id"
          label="Sales"
          rules={[{ required: true, message: 'Pilih sales yang akan menangani percakapan ini' }]}
        >
          <Select
            placeholder="Pilih sales"
            loading={loadingUsers}
            showSearch
            optionFilterProp="children"
          >
            {salesUsers.map((u) => (
              <Option key={u.id} value={u.id}>
                {u.full_name}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item name="create_lead" valuePropName="checked">
          <Checkbox disabled={!!conversation?.lead_id}>
            Buat lead baru otomatis
          </Checkbox>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AssignModal;
